import type { MaterialInfo, PartDefinition } from "@rogue/rackbuilder"
import { getRackModel } from "../../modelPaths"
import { addPlateStorage } from "../../utils/plate-storage"
import { BarBuilder, PlateAmount } from "../bar/barBuilder"
import { PowerRackBuilder } from "../rack/powerRack/powerRackBuilder"

export class CavePowerRackBuilder extends PowerRackBuilder {
  public leftJCup: PartDefinition | undefined

  protected addStorageRow(backUpright: PartDefinition, left: boolean ): void {
   
    const blackMaterial: MaterialInfo = { main: { material: 'mg', color: 'black' }, hardware: { material: this.config.hardware } }
    const baseMaterial: MaterialInfo  = { main: { name: 'metal', material: 'base' }, hardware: { material: this.config.hardware } }

    // RM/RML-6 storage upright
    const thirdRowUpright: PartDefinition = {
      mesh      : this.getUprightMesh(),
      anchor    : 'crossmember-bottom',
      materials : blackMaterial,
      ...this.getSideTransform(left),
      slots     : {},
    }

    // The Cave also has an extra crossmember on the far back uprights
    if (left) {
      thirdRowUpright.slots['top'] = {
        mesh        : getRackModel('RM_LRLP', 'rm crossmember top 4'),
        slots       : {},
        anchor      : 'back',
        materials   : blackMaterial,
        adjustments : [{ type: 'rotate', axis: 'Y', amount: 90 }],
        offset      : { y: 1 },
      }
    }
   
    if (this.config.plateStorage) {
      const leftFirstRowPlates = BarBuilder.createPlates(this.config.plates, PlateAmount.HeavyPlates, true)
      const rightFirstRowPlates = BarBuilder.createPlates(this.config.plates, PlateAmount.HeavyPlates, false, 6.5)
    
      const leftSecondRowPlates =   BarBuilder.createPlates(this.config.plates, PlateAmount.LightPlates, true, -0.5)
      const rightSecondRowPlates =   BarBuilder.createPlates(this.config.plates, PlateAmount.LightPlates, false, 6)
    
      const storagePins = addPlateStorage(
        this.config,
        left,
        this.material,
        this.getSideTransform(left),
        this.config.plateStorage,
        leftFirstRowPlates,
        rightFirstRowPlates,
        leftSecondRowPlates,
        rightSecondRowPlates
      )

      // Add storage pin for plates to the back upright
      thirdRowUpright.slots.storage = storagePins
    }
    
    // The Cave uses a special crossmember for the storage from LRLP unlike the RM-6
    backUpright.slots['crossmember-bottom'] = {
      mesh      : getRackModel('RM_LRLP', 'rm crossmember bottom 1'),
      slots     : { back: thirdRowUpright },
      anchor    : 'front',
      materials : baseMaterial,
    }

    backUpright.slots['crossmember-top'] = {
      mesh      : getRackModel('RM_LRLP', 'rm crossmember top 1'),
      slots     : {},
      anchor    : 'front',
      materials : baseMaterial,
      ...this.getSideTransform(left),
    }
  }

  protected addAccessories(frontUpright: PartDefinition, backUpright: PartDefinition, left: boolean): void {
    // Safeties
    if (this.config.safeties) {
      frontUpright.slots['safety-high'] = this.accessoryBuilder.createSafety(left)
    }

    const jcup = this.accessoryBuilder.createJCup(left)

    if (left) this.leftJCup = jcup

    if (this.config.height === '80') {
      jcup.offset = { y: -2 }
    }
    
    // J-cups (on back upright for full racks)
    if (this.config.jcup && this.config.sixPost) {
      backUpright.slots['jcup-high'] = jcup
      
      // Add bar to j-cup if configured
      if (this.config.bar && left) {
        jcup.slots.bar = this.accessoryBuilder.createBar()
      }
    } else if (this.config.jcup && !this.config.sixPost) {
      frontUpright.slots['jcup-high'] = jcup // Place jcups on the front upright for half racks 
    }
    
    // Spotter arms
    if (this.config.spotterArms) {
      frontUpright.slots['safety-low'] = this.accessoryBuilder.createSpotterArms(left)
    }
    
    // Band pegs
    if (this.config.bandPegs) {
      this.accessoryBuilder.addBandPegs(frontUpright, backUpright, left)
    }
  }
}